import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Box,
  Button,
  Dialog, DialogContent, DialogTitle, IconButton, Stack
} from '@mui/material';
import {
  FieldFormik,
  Fieldrow,
  Textarea
} from 'components/atoms';
import { Formik } from 'formik';
import { useCallback } from 'react';

import { defaultInitialCriteriaValues, filterSchema } from './filterSchema';

const FilterModal = (props: any) => {
  const { isOpen = false, onCancel, onOk, initialValues } = props;

  const handleSubmit = useCallback(async (values: any, action: any) => {
    try {
      onOk && await onOk(values);
    } catch (err) {
      action.setSubmitting(false);
    }
  }, [onOk])

  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth={true} maxWidth="sm">
      <DialogTitle>
        {initialValues ? 'Edit' : 'Add'} filter
        <IconButton
          onClick={onCancel}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Formik
          initialValues={initialValues || defaultInitialCriteriaValues}
          validationSchema={filterSchema}
          onSubmit={handleSubmit}
        >
          {({ isValid, dirty, isSubmitting, handleSubmit, values }) => {
            return (
              <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                  <Fieldrow name="name">
                    <FieldFormik type="text" label="Filter name" placeholder="Enter a filter name" name="name" readonly={false} />
                  </Fieldrow>
                </Stack>
                <Stack spacing={2} mt={2}>
                  <Fieldrow name="description">
                    <Textarea label="Description" placeholder="Enter a description" name="description" value={values.description} />
                  </Fieldrow>
                </Stack>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: '10px', gap: '8px' }}>
                  <Button variant="outlined" onClick={onCancel}>Cancel</Button>
                  <LoadingButton variant="contained" type='submit' loading={isSubmitting} disabled={!dirty || !isValid}>
                    Save
                  </LoadingButton>
                </Box>
              </form>
            );
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}

export default FilterModal;
